import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthorizationService } from "../services/authorization.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authorizationService: AuthorizationService,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const authenticated = await this.authorizationService.isAuthenticated();
    if (authenticated) return true;
    return false;
  }

}
